// extracted by mini-css-extract-plugin
module.exports = {"noContainerWrap":"ContainerPreview_noContainerWrap__1CVX+","txt":"ContainerPreview_txt__GE3dD"};